"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
var _src = require("@seedlang/utils/src");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var VocabWordWrapper = function VocabWordWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "sentence", _descriptor, _this);
      _initializerDefineProperty(_this, "expandedId", _descriptor2, _this);
      _initializerDefineProperty(_this, "autoPlay", _descriptor3, _this);
      _initializerDefineProperty(_this, "sentencesLoaded", _descriptor4, _this);
      _initializerDefineProperty(_this, "verbConjugationsLoaded", _descriptor5, _this);
      _initializerDefineProperty(_this, "showSourceInput", _descriptor6, _this);
      _initializerDefineProperty(_this, "loadingNewWord", _descriptor7, _this);
      if (_state.AppUI.wordStore.hasShowData) {
        _this.getConjugations();
      } else if ((0, _utils.isPresent)(_this.wordId)) {
        _this.loadingNewWord = true;
        _state.AppUI.wordStore.getShow({
          ids: {
            wordId: _this.wordId
          }
        }, _this.afterGetWord);
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _prevProps$route;
        var prevWordId = (0, _utils.isPresent)(prevProps.params) ? prevProps.params.wordId : (_prevProps$route = prevProps.route) === null || _prevProps$route === void 0 || (_prevProps$route = _prevProps$route.params) === null || _prevProps$route === void 0 ? void 0 : _prevProps$route.wordId;
        if (!_state.AppUI.wordStore.hasShowData || (0, _utils.isPresent)(this.wordId) && (0, _utils.isPresent)(prevWordId) && prevWordId !== this.wordId) {
          _state.AppUI.wordStore.getShow({
            ids: {
              wordId: this.wordId
            }
          }, this.afterGetWord);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _state.AppUI.wordStore.clearShowData();
        _state.AppUI.conjugatedVerbStringStore.clearIndexData();
        _state.AppUI.cardStore.clearIndexData();
      }
    }, {
      key: "hasVerbConjugations",
      get: function get() {
        return _state.AppUI.conjugatedVerbStringStore.hasIndexData;
      }
    }, {
      key: "showSpinner",
      get: function get() {
        return !this.verbConjugationsLoaded || this.loadingNewWord;
      }
    }, {
      key: "hasVideoClip",
      get: function get() {
        return (0, _utils.isPresent)(this.videoClip) && this.videoClip.mp4Url;
      }
    }, {
      key: "hasSentence",
      get: function get() {
        return (0, _utils.isPresent)(this.sentence);
      }
    }, {
      key: "hasWord",
      get: function get() {
        return _state.AppUI.wordStore.hasIndexData;
      }
    }, {
      key: "word",
      get: function get() {
        return _state.AppUI.wordStore.showData;
      }
    }, {
      key: "showNoPlural",
      get: function get() {
        return this.word.isNoun && this.word.noPlural;
      }
    }, {
      key: "showPlural",
      get: function get() {
        return this.word.isNoun && !this.word.noPlural && (0, _utils.isPresent)(this.word.pluralNoun);
      }
    }, {
      key: "videoClip",
      get: function get() {
        if (this.sentence && this.sentence.target) {
          return this.sentence.target.videoClip;
        } else if (this.word && this.word.target && this.word.target.videoClip) {
          return this.word.target.videoClip;
        }
      }
    }, {
      key: "supplementVideoClip",
      get: function get() {
        return this.sentence && this.sentence.videoClip;
      }
    }, {
      key: "supplementImageUrl",
      get: function get() {
        return this.sentence && this.sentence.hasImage && this.sentence.image.url;
      }
    }, {
      key: "tabs",
      get: function get() {
        var _this$word, _this$word2, _this$word3;
        var tabs = [{
          name: 'sentences',
          label: 'Sentences',
          "default": true
        }];
        if (!_state.AppUI.layout.isNative && _state.AppUI.siteIsDefault) {
          tabs.push({
            name: 'submit-sentence',
            label: _state.AppUI.layout.isMobile ? 'Submit' : 'Submit Sentence'
          });
        }
        tabs.push({
          name: 'comments',
          label: "".concat((0, _utils.isPresent)((_this$word = this.word) === null || _this$word === void 0 ? void 0 : _this$word.commentsCount) ? "".concat(this.word.commentsCount, " ") : '', "Comment").concat(this.word.commentsCount === 1 || (0, _src.isBlank)((_this$word2 = this.word) === null || _this$word2 === void 0 ? void 0 : _this$word2.commentsCount) ? '' : 's')
        });
        if ((_this$word3 = this.word) !== null && _this$word3 !== void 0 && _this$word3.isVerb && this.hasVerbConjugations) {
          tabs.push({
            name: 'conjugations',
            label: _state.AppUI.layout.isMobile || _state.AppUI.layout.isNative ? 'Conjugations' : 'Verb Conjugations'
          });
        }
        return tabs;
      }
    }, {
      key: "wordId",
      get: function get() {
        var _this$props$params, _this$props$route;
        if ((_this$props$params = this.props.params) !== null && _this$props$params !== void 0 && _this$props$params.wordId) {
          return this.props.params.wordId;
        }
        if ((_this$props$route = this.props.route) !== null && _this$props$route !== void 0 && (_this$props$route = _this$props$route.params) !== null && _this$props$route !== void 0 && _this$props$route.wordId) {
          var _this$props$route$par;
          return (_this$props$route$par = this.props.route.params) === null || _this$props$route$par === void 0 ? void 0 : _this$props$route$par.wordId;
        }
        if (_state.AppUI.wordStore.hasShowData) {
          return _state.AppUI.wordStore.showData.id;
        }
      }
    }, {
      key: "expandSourceInput",
      value: function expandSourceInput() {
        this.showSourceInput = true;
      }
    }, {
      key: "playSentenceVideo",
      value: function playSentenceVideo(sentence) {
        this.autoPlay = true;
        this.sentence = sentence;
      }
    }, {
      key: "afterGetWord",
      value: function afterGetWord(resp) {
        _state.AppUI.wordStore.setShowData(resp);
        this.loadingNewWord = false;
        this.getConjugations();
        _state.AppUI.createEvent('vocab - view word page', {
          language_id: this.word.languageId,
          target_text: this.word.targetText
        });
      }
    }, {
      key: "getConjugations",
      value: function getConjugations() {
        if (this.word.isVerb) {
          _state.AppUI.conjugatedVerbStringStore.getIndex({
            ids: {
              wordId: this.wordId
            }
          }, this.afterGetConjugatedVerbStrings);
        } else {
          this.verbConjugationsLoaded = true;
        }
      }
    }, {
      key: "afterGetConjugatedVerbStrings",
      value: function afterGetConjugatedVerbStrings(resp) {
        _state.AppUI.conjugatedVerbStringStore.setIndexData(resp);
        this.verbConjugationsLoaded = true;
      }
    }, {
      key: "onClickSentence",
      value: function onClickSentence(sentence) {
        this.popupSentence = sentence;
      }
    }, {
      key: "onToggleSourceInput",
      value: function onToggleSourceInput() {
        this.showSourceInput = !this.showSourceInput;
      }
    }, {
      key: "afterSubmitSourceInput",
      value: function afterSubmitSourceInput() {
        _state.AppUI.wordStore.getShow({
          ids: {
            wordId: this.wordId
          }
        });
      }
    }, {
      key: "playWordVideo",
      value: function playWordVideo() {
        this.autoPlay = true;
        this.sentence = null;
      }
    }, {
      key: "onClickRow",
      value: function onClickRow(id) {
        this.expandedId = this.expandedId === id ? null : id;
      }
    }, {
      key: "relatedWords",
      get: function get() {
        if ((0, _src.isBlank)(this.word)) {
          return;
        }
        return (0, _lodash.uniqBy)(this.word.relatedWords.filter(function (item) {
          return item.publicInVocab;
        }), function (item) {
          return item.id;
        });
      }
    }, {
      key: "onClickWord",
      value: function onClickWord(word) {
        this.loadingNewWord = true;
        _state.VocabUI.setWord(word);
        if ((0, _utils.isPresent)(this.props.card)) {
          _state.DeckUI.gotoWordVocabCard(word);
        } else if (!_state.VocabUI.layout.isNative) {
          _state.AppUI.routeStore.routeToNamed('vocab.word', {
            wordId: word.id
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          wordId: this.wordId,
          expandSourceInput: this.expandSourceInput,
          playSentenceVideo: this.playSentenceVideo,
          playWordVideo: this.playWordVideo,
          afterGetWord: this.afterGetWord,
          afterGetConjugatedVerbStrings: this.afterGetConjugatedVerbStrings,
          onToggleCreateReview: this.onToggleCreateReview,
          onToggleSourceInput: this.onToggleSourceInput,
          afterGetSentences: this.afterGetSentences,
          afterSubmitSourceInput: this.afterSubmitSourceInput,
          hasVerbConjugations: this.hasVerbConjugations,
          showSpinner: this.showSpinner,
          hasVideoClip: this.hasVideoClip,
          hasSentence: this.hasSentence,
          hasWord: this.hasWord,
          word: this.word,
          videoClip: this.videoClip,
          supplementVideoClip: this.supplementVideoClip,
          supplementImageUrl: this.supplementImageUrl,
          tabs: this.tabs,
          sentence: this.sentence,
          autoPlay: this.autoPlay,
          verbConjugationsLoaded: this.verbConjugationsLoaded,
          showSourceInput: this.showSourceInput,
          onClickSentence: this.onClickSentence,
          popupSentence: this.popupSentence,
          showNoPlural: this.showNoPlural,
          showPlural: this.showPlural,
          onClickRow: this.onClickRow,
          expandedId: this.expandedId,
          relatedWords: this.relatedWords,
          onClickWord: this.onClickWord,
          onToggleLearned: _state.VocabUI.onToggleLearned
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "sentence", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "expandedId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "autoPlay", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "sentencesLoaded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "verbConjugationsLoaded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "showSourceInput", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "loadingNewWord", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "hasVerbConjugations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasVerbConjugations"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasSentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "word", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "word"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showNoPlural", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showNoPlural"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showPlural", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showPlural"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "videoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "videoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "supplementVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "supplementVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "supplementImageUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "supplementImageUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "tabs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "tabs"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "expandSourceInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "expandSourceInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "playSentenceVideo", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "playSentenceVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetWord", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getConjugations", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getConjugations"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetConjugatedVerbStrings", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetConjugatedVerbStrings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickSentence", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickSentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleSourceInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleSourceInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterSubmitSourceInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterSubmitSourceInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "playWordVideo", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "playWordVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickRow", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickRow"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "relatedWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "relatedWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickWord", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickWord"), _class2.prototype), _class2)) || _class;
};
VocabWordWrapper.displayName = 'VocabWordWrapper';
var _default = exports["default"] = VocabWordWrapper;